import React, {useEffect, useState} from "react";
import {EditButton} from "../../../helpers/ButtonHelper";
import {saveData} from "../../../helpers/Api";
import {Modal} from "react-bootstrap";
import {useMutation} from "@apollo/client";
import MenuPlateForm from "./MenuPlateForm";
import {getMenuPlates, UpdateMenuPlateMutation} from "./MenuQueries";

const EditMenuPlateModal = ({
                              menuPlate,
                              onClose,
                              shouldOpen,
                              showButton
                            }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});
  const [gqlCall] = useMutation(UpdateMenuPlateMutation, {refetchQueries: [getMenuPlates]})

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
    // resetForm();
  }
  const showModal = (e) => {
    e.preventDefault()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: gqlCall,
      query_key: 'updateMenuItem',
      success: (res) => {
        closeModal()
      },
      flash_callback: setFlash
    })
  }

  return (
    <>
      {showButton && <EditButton onClick={showModal}/>}
      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Modifica masa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row justify-content-md-center">
              <MenuPlateForm
                onSubmit={onSubmit}
                menuPlate={menuPlate}
                flash={flash}/>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default EditMenuPlateModal;